import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  bottomSheetContainer: {
    flex: 1,
    marginBottom: 20,
  },
  bottomSheetButtonContainer: {
    width: '100%',
    height: 45,
    paddingHorizontal: 7,
    justifyContent: 'center',
  },
})

export default styles
